
import { Component, mixins } from 'nuxt-property-decorator';
import {
  VideoBlockModel,
  contentBlockVideoPositionModifiersMap,
  contentBlockTextVerticalAlignmentModifiersMap,
} from 'fourwaves-shared';
import { RawHtml } from 'fourwaves-shared/components';
import ContentBlockMixin from '../ContentBlockMixin';
import ContentBlockVideo from './ContentBlockVideo.vue';

@Component({
  components: {
    RawHtml,
    ContentBlockVideo,
  },
})
export default class VideoBlock extends mixins(ContentBlockMixin<VideoBlockModel>) {
  get blockClassNames(): string[] {
    return [
      contentBlockVideoPositionModifiersMap[this.settings.videoPosition],
      contentBlockTextVerticalAlignmentModifiersMap[this.settings.textVerticalAlignment],
      ...(this.settings.withIntro ? ['-with-intro'] : []),
    ];
  }
}
